// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import ClientHeader from '../Common/Layout/ClientHeader';
// import { rexTechTheme } from '../Common/Theme';
// import {
//   GitBranch,
//   Users,
//   Package,
//   CheckCircle,
//   Leaf,
//   BarChart3,
//   Calendar,
//   RefreshCw,
//   TrendingUp,
//   Globe,
//   TrendingDown,
//   TrendingUp as ArrowUp,
//   TrendingDown as ArrowDown
// } from 'lucide-react';
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer
// } from 'recharts';

// // Import your API configuration
// import config from '../Common/Configurations/APIConfig';

// const ClientDashboard = () => {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(true);
//   const [isRefreshing, setIsRefreshing] = useState(false);
//   const [stats, setStats] = useState({
//     branches: 0,
//     branchUsers: 0,
//     requests: 0,
//     requestsCollected: 0,
//     co2Reduction: 0,
//     totalMaterialsKg: 0
//   });

//   // Trend data
//   const [trendData, setTrendData] = useState({
//     branchTrend: '0%',
//     branchDirection: 'up',
//     co2Trend: '0%',
//     co2Direction: 'up'
//   });

//   // Materials recycled data for graph
//   const [materialsRecycledData, setMaterialsRecycledData] = useState([]);
  
//   // Filter states
//   const [periodFilter, setPeriodFilter] = useState('week');



//   // Fetch dashboard data
//   const fetchDashboardData = async (period = periodFilter) => {
//     try {
//       setIsLoading(true);
//       setIsRefreshing(true);
      
//       // Get current user ID
//       const userId =localStorage.getItem('userId');
      
//       if (!userId) {
//         console.error('No user ID found. User might not be logged in.');
//         alert('Please log in to view dashboard data.');
//         navigate('/login');
//         return;
//       }

//       // Single API call for all dashboard data
//       const response = await axios.get(
//         `${config.APIACTIVEURL}dashboard/data?userId=${userId}&period=${period}`,
//         {
//           headers: {
//             'Authorization': `Bearer ${localStorage.getItem('token')}`,
//             'Content-Type': 'application/json'
//           }
//         }
//       );

//       if (response.data.success) {
//         const dashboardData = response.data.data;
//         const stats = dashboardData.stats;
        
//         // Update stats for cards
//         setStats({
//           branches: stats?.branches || 0,
//           branchUsers: stats?.branchUsers || 0,
//           requests: stats?.requests || 0,
//           requestsCollected: stats?.requestsCollected || 0,
//           co2Reduction: stats?.co2ReductionKg || 0,
//           totalMaterialsKg: stats?.totalMaterialsKg || 0
//         });

//         // Update trend data
//         setTrendData({
//           branchTrend: stats?.branchTrend || '0%',
//           branchDirection: stats?.branchTrendDirection || 'up',
//           co2Trend: stats?.co2Trend || '0%',
//           co2Direction: stats?.co2TrendDirection || 'up'
//         });

//         // Update chart data
//         if (dashboardData?.materialsChartData && dashboardData.materialsChartData.length > 0) {
//           setMaterialsRecycledData(dashboardData.materialsChartData.map(item => ({
//             period: item.period,
//             amount: item.amount || 0,
//             co2Saved: item.co2Saved || 0
//           })));
//         } else {
//           setMaterialsRecycledData([]);
//         }
//       } else {
//         alert(`Failed to load dashboard data: ${response.data.message}`);
//       }

//     } catch (error) {
//       console.error('Error fetching dashboard data:', error);
      
//       // Handle errors
//       if (error.response?.status === 401) {
//         localStorage.removeItem('token');
//         localStorage.removeItem('user');
//         navigate('/login');
//       } else if (error.response?.status === 403) {
//         alert('Access denied. You need client privileges.');
//       } else if (error.response?.status === 400) {
//         alert(`Bad request: ${error.response.data.message}`);
//       } else if (error.response?.status === 404) {
//         alert('Dashboard endpoint not found. Please check API configuration.');
//       } else {
//         alert('Failed to load dashboard data. Please try again.');
//       }
//     } finally {
//       setIsLoading(false);
//       setIsRefreshing(false);
//     }
//   };

//   // Initial data fetch
//   useEffect(() => {
//     fetchDashboardData();
//   }, []);

//   // Handle period change
//   const handlePeriodChange = (period) => {
//     setPeriodFilter(period);
//     fetchDashboardData(period);
//   };

//   // Handle refresh
//   const handleRefresh = () => {
//     fetchDashboardData();
//   };

//   // Stats Card Component
//   const StatsCard = ({ title, value, icon: Icon, color, trendValue, trendDirection, unit, loading }) => {
//     const formatValue = (val) => {
//       if (unit === 'kg' && val >= 1000) {
//         return `${(val / 1000).toFixed(1)}`;
//       }
//       if (unit === 'kg') {
//         return `${val.toLocaleString()}`;
//       }
//       return val.toLocaleString();
//     };

//     const getUnitDisplay = () => {
//       if (unit === 'kg' && value >= 1000) return 'tons';
//       if (unit === 'kg') return 'kg';
//       return '';
//     };

//     const TrendIcon = trendDirection === 'up' ? ArrowUp : ArrowDown;
//     const trendColor = trendDirection === 'up' ? rexTechTheme.colors.primary.main : '#dc3545';

//     return (
//       <div
//         style={{
//           backgroundColor: rexTechTheme.colors.neutral.white,
//           borderRadius: rexTechTheme.borderRadius.large,
//           padding: rexTechTheme.spacing.xl,
//           boxShadow: rexTechTheme.shadows.light,
//           border: `1px solid ${rexTechTheme.colors.neutral.gray}`,
//           transition: 'all 0.3s ease',
//           position: 'relative',
//           overflow: 'hidden',
//           minHeight: '140px',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'space-between'
//         }}
//       >
//         {/* Background accent */}
//         <div style={{
//           position: 'absolute',
//           top: 0,
//           right: 0,
//           width: '60px',
//           height: '60px',
//           backgroundColor: `${color}10`,
//           borderRadius: '0 0 0 100%',
//           transition: 'all 0.3s ease'
//         }} />
        
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//           <div style={{ flex: 1 }}>
//             <p style={{
//               color: rexTechTheme.colors.neutral.darkGray,
//               fontSize: rexTechTheme.typography.fontSize.regular,
//               marginBottom: rexTechTheme.spacing.xs,
//               fontWeight: rexTechTheme.typography.fontWeight.medium
//             }}>
//               {title}
//             </p>
//             <div style={{
//               display: 'flex',
//               alignItems: 'baseline',
//               gap: rexTechTheme.spacing.xs,
//               minHeight: '40px'
//             }}>
//               <h3 style={{
//                 color: rexTechTheme.colors.primary.dark,
//                 fontSize: rexTechTheme.typography.fontSize.xxxlarge,
//                 fontWeight: rexTechTheme.typography.fontWeight.bold,
//                 margin: 0,
//                 lineHeight: 1
//               }}>
//                 {loading ? (
//                   <div style={{
//                     width: '24px',
//                     height: '24px',
//                     border: `2px solid ${rexTechTheme.colors.primary.light}`,
//                     borderTopColor: rexTechTheme.colors.primary.main,
//                     borderRadius: '50%',
//                     animation: 'spin 1s linear infinite'
//                   }} />
//                 ) : (
//                   formatValue(value)
//                 )}
//               </h3>
//               {unit && !loading && (
//                 <span style={{
//                   color: rexTechTheme.colors.neutral.darkGray,
//                   fontSize: rexTechTheme.typography.fontSize.small,
//                   fontWeight: rexTechTheme.typography.fontWeight.medium
//                 }}>
//                   {getUnitDisplay()}
//                 </span>
//               )}
//             </div>
            
//             {trendValue && !loading && (
//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: rexTechTheme.spacing.xs,
//                 marginTop: rexTechTheme.spacing.sm
//               }}>
//                 <TrendIcon size={16} color={trendColor} />
//                 <span style={{
//                   color: trendColor,
//                   fontSize: rexTechTheme.typography.fontSize.small,
//                   fontWeight: rexTechTheme.typography.fontWeight.semiBold
//                 }}>
//                   {trendValue}
//                 </span>
//                 <span style={{
//                   color: rexTechTheme.colors.neutral.darkGray,
//                   fontSize: rexTechTheme.typography.fontSize.xs,
//                   marginLeft: rexTechTheme.spacing.xs
//                 }}>
//                   from last month
//                 </span>
//               </div>
//             )}
//           </div>
          
//           <div style={{
//             width: '48px',
//             height: '48px',
//             borderRadius: '12px',
//             backgroundColor: `${color}20`,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             color: color,
//             flexShrink: 0
//           }}>
//             <Icon size={24} />
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Custom Tooltip for Chart
//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div style={{
//           backgroundColor: rexTechTheme.colors.neutral.white,
//           border: `1px solid ${rexTechTheme.colors.neutral.gray}`,
//           padding: rexTechTheme.spacing.md,
//           borderRadius: rexTechTheme.borderRadius.medium,
//           boxShadow: rexTechTheme.shadows.medium
//         }}>
//           <p style={{
//             margin: 0,
//             color: rexTechTheme.colors.primary.dark,
//             fontWeight: 'bold',
//             marginBottom: rexTechTheme.spacing.xs
//           }}>
//             {label}
//           </p>
//           {payload.map((entry, index) => (
//             <p key={index} style={{
//               margin: 0,
//               color: entry.color,
//               fontSize: rexTechTheme.typography.fontSize.small,
//               display: 'flex',
//               alignItems: 'center',
//               gap: rexTechTheme.spacing.xs,
//               marginBottom: rexTechTheme.spacing.xs
//             }}>
//               <div style={{
//                 width: '10px',
//                 height: '10px',
//                 backgroundColor: entry.color,
//                 borderRadius: '2px'
//               }} />
//               {entry.name}: <strong>{entry.value.toLocaleString()} kg</strong>
//             </p>
//           ))}
//         </div>
//       );
//     }
//     return null;
//   };

//   // Loading skeleton
//   const LoadingSkeleton = () => (
//     <div style={{
//       minHeight: '100vh',
//       backgroundColor: rexTechTheme.colors.neutral.lightGray,
//       fontFamily: rexTechTheme.typography.fontFamily
//     }}>
//       <ClientHeader />
      
//       <div style={{
//         maxWidth: '1400px',
//         margin: '0 auto',
//         padding: rexTechTheme.spacing.xl
//       }}>
//         {/* Header skeleton */}
//         <div style={{ marginBottom: rexTechTheme.spacing.xl }}>
//           <div style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             marginBottom: rexTechTheme.spacing.lg
//           }}>
//             <div>
//               <div style={{
//                 width: '200px',
//                 height: '32px',
//                 backgroundColor: rexTechTheme.colors.neutral.gray,
//                 borderRadius: rexTechTheme.borderRadius.medium,
//                 marginBottom: rexTechTheme.spacing.xs
//               }} />
//               <div style={{
//                 width: '300px',
//                 height: '20px',
//                 backgroundColor: rexTechTheme.colors.neutral.gray,
//                 borderRadius: rexTechTheme.borderRadius.medium
//               }} />
//             </div>
//             <div style={{
//               width: '120px',
//               height: '40px',
//               backgroundColor: rexTechTheme.colors.neutral.gray,
//               borderRadius: rexTechTheme.borderRadius.medium
//             }} />
//           </div>
//         </div>

//         {/* Stats grid skeleton */}
//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//           gap: rexTechTheme.spacing.lg,
//           marginBottom: rexTechTheme.spacing.xl
//         }}>
//           {[1, 2, 3, 4, 5].map((item) => (
//             <div key={item} style={{
//               backgroundColor: rexTechTheme.colors.neutral.white,
//               borderRadius: rexTechTheme.borderRadius.large,
//               padding: rexTechTheme.spacing.xl,
//               height: '140px',
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'space-between'
//             }}>
//               <div style={{
//                 width: '80px',
//                 height: '20px',
//                 backgroundColor: rexTechTheme.colors.neutral.gray,
//                 borderRadius: rexTechTheme.borderRadius.medium
//               }} />
//               <div style={{
//                 width: '60px',
//                 height: '32px',
//                 backgroundColor: rexTechTheme.colors.neutral.gray,
//                 borderRadius: rexTechTheme.borderRadius.medium
//               }} />
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );

//   if (isLoading) {
//     return <LoadingSkeleton />;
//   }

//   return (
//     <div style={{
//       minHeight: '100vh',
//       backgroundColor: rexTechTheme.colors.neutral.lightGray,
//       fontFamily: rexTechTheme.typography.fontFamily
//     }}>
//       <ClientHeader />
      
//       <div style={{
//         maxWidth: '1400px',
//         margin: '0 auto',
//         padding: rexTechTheme.spacing.xl
//       }}>
//         {/* Header */}
//         <div style={{
//           marginBottom: rexTechTheme.spacing.xl
//         }}>
//           <div style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             marginBottom: rexTechTheme.spacing.lg
//           }}>
//             <div>
//               <h1 style={{
//                 fontSize: rexTechTheme.typography.fontSize.xxlarge,
//                 color: rexTechTheme.colors.primary.dark,
//                 fontWeight: rexTechTheme.typography.fontWeight.bold,
//                 marginBottom: rexTechTheme.spacing.xs,
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: rexTechTheme.spacing.sm
//               }}>
//                 <BarChart3 size={32} />
//                 Client Dashboard
//               </h1>
//               <p style={{
//                 color: rexTechTheme.colors.neutral.darkGray,
//                 fontSize: rexTechTheme.typography.fontSize.regular,
//                 margin: 0,
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: rexTechTheme.spacing.sm
//               }}>
//                 <Calendar size={16} />
//                 {new Date().toLocaleDateString('en-US', { 
//                   weekday: 'long', 
//                   year: 'numeric', 
//                   month: 'long', 
//                   day: 'numeric' 
//                 })}
//               </p>
//             </div>
            
//             <div style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: rexTechTheme.spacing.md
//             }}>
//               <button
//                 onClick={handleRefresh}
//                 disabled={isRefreshing}
//                 style={{
//                   padding: `${rexTechTheme.spacing.sm} ${rexTechTheme.spacing.lg}`,
//                   backgroundColor: rexTechTheme.colors.neutral.white,
//                   border: `1px solid ${rexTechTheme.colors.neutral.gray}`,
//                   borderRadius: rexTechTheme.borderRadius.medium,
//                   cursor: 'pointer',
//                   color: rexTechTheme.colors.primary.dark,
//                   fontSize: rexTechTheme.typography.fontSize.regular,
//                   fontWeight: rexTechTheme.typography.fontWeight.semiBold,
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: rexTechTheme.spacing.sm,
//                   transition: 'all 0.2s ease',
//                   ':hover': {
//                     backgroundColor: rexTechTheme.colors.neutral.lightGray
//                   },
//                   ':disabled': {
//                     opacity: 0.6,
//                     cursor: 'not-allowed'
//                   }
//                 }}
//               >
//                 <RefreshCw size={18} className={isRefreshing ? 'spin' : ''} />
//                 {isRefreshing ? 'Refreshing...' : 'Refresh'}
//               </button>
//             </div>
//           </div>
          
//           {/* Date Filters */}
//           <div style={{
//             backgroundColor: rexTechTheme.colors.neutral.white,
//             borderRadius: rexTechTheme.borderRadius.large,
//             padding: rexTechTheme.spacing.lg,
//             boxShadow: rexTechTheme.shadows.light,
//             border: `1px solid ${rexTechTheme.colors.neutral.gray}`,
//             marginBottom: rexTechTheme.spacing.lg
//           }}>
//             <div style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: rexTechTheme.spacing.sm
//             }}>
//               <span style={{
//                 color: rexTechTheme.colors.neutral.darkGray,
//                 fontWeight: rexTechTheme.typography.fontWeight.medium,
//                 fontSize: rexTechTheme.typography.fontSize.small
//               }}>
//                 View Data:
//               </span>
//               <button
//                 onClick={() => handlePeriodChange('day')}
//                 style={{
//                   padding: `${rexTechTheme.spacing.xs} ${rexTechTheme.spacing.lg}`,
//                   backgroundColor: periodFilter === 'day' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.white,
//                   border: `1px solid ${periodFilter === 'day' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.gray}`,
//                   borderRadius: rexTechTheme.borderRadius.medium,
//                   cursor: 'pointer',
//                   color: periodFilter === 'day' ? rexTechTheme.colors.neutral.white : rexTechTheme.colors.primary.dark,
//                   fontSize: rexTechTheme.typography.fontSize.small,
//                   fontWeight: rexTechTheme.typography.fontWeight.semiBold,
//                   transition: 'all 0.2s ease',
//                   ':hover': {
//                     backgroundColor: periodFilter === 'day' ? rexTechTheme.colors.primary.dark : rexTechTheme.colors.neutral.lightGray
//                   }
//                 }}
//               >
//                 Today
//               </button>
//               <button
//                 onClick={() => handlePeriodChange('week')}
//                 style={{
//                   padding: `${rexTechTheme.spacing.xs} ${rexTechTheme.spacing.lg}`,
//                   backgroundColor: periodFilter === 'week' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.white,
//                   border: `1px solid ${periodFilter === 'week' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.gray}`,
//                   borderRadius: rexTechTheme.borderRadius.medium,
//                   cursor: 'pointer',
//                   color: periodFilter === 'week' ? rexTechTheme.colors.neutral.white : rexTechTheme.colors.primary.dark,
//                   fontSize: rexTechTheme.typography.fontSize.small,
//                   fontWeight: rexTechTheme.typography.fontWeight.semiBold,
//                   transition: 'all 0.2s ease',
//                   ':hover': {
//                     backgroundColor: periodFilter === 'week' ? rexTechTheme.colors.primary.dark : rexTechTheme.colors.neutral.lightGray
//                   }
//                 }}
//               >
//                 This Week
//               </button>
//               <button
//                 onClick={() => handlePeriodChange('month')}
//                 style={{
//                   padding: `${rexTechTheme.spacing.xs} ${rexTechTheme.spacing.lg}`,
//                   backgroundColor: periodFilter === 'month' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.white,
//                   border: `1px solid ${periodFilter === 'month' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.gray}`,
//                   borderRadius: rexTechTheme.borderRadius.medium,
//                   cursor: 'pointer',
//                   color: periodFilter === 'month' ? rexTechTheme.colors.neutral.white : rexTechTheme.colors.primary.dark,
//                   fontSize: rexTechTheme.typography.fontSize.small,
//                   fontWeight: rexTechTheme.typography.fontWeight.semiBold,
//                   transition: 'all 0.2s ease',
//                   ':hover': {
//                     backgroundColor: periodFilter === 'month' ? rexTechTheme.colors.primary.dark : rexTechTheme.colors.neutral.lightGray
//                   }
//                 }}
//               >
//                 This Month
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Stats Grid - 5 Cards with Trends */}
//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//           gap: rexTechTheme.spacing.lg,
//           marginBottom: rexTechTheme.spacing.xl
//         }}>
//           <StatsCard
//             title="Branches"
//             value={stats.branches}
//             icon={GitBranch}
//             color={rexTechTheme.colors.secondary.main}
//             trendValue={trendData.branchTrend}
//             trendDirection={trendData.branchDirection}
//             loading={isRefreshing}
//           />
          
//           <StatsCard
//             title="Branch Users"
//             value={stats.branchUsers}
//             icon={Users}
//             color={rexTechTheme.colors.primary.light}
//             loading={isRefreshing}
//           />
          
//           <StatsCard
//             title="Requests"
//             value={stats.requests}
//             icon={Package}
//             color={rexTechTheme.colors.accent.orange}
//             loading={isRefreshing}
//           />
          
//           <StatsCard
//             title="Requests Collected"
//             value={stats.requestsCollected}
//             icon={CheckCircle}
//             color={rexTechTheme.colors.primary.main}
//             loading={isRefreshing}
//           />
          
//           <StatsCard
//             title="CO2 Reduction"
//             value={stats.co2Reduction}
//             icon={Leaf}
//             color={rexTechTheme.colors.primary.main}
//             trendValue={trendData.co2Trend}
//             trendDirection={trendData.co2Direction}
//             unit="kg"
//             loading={isRefreshing}
//           />
          
//           {/* <StatsCard
//             title="Materials Recycled"
//             value={stats.totalMaterialsKg}
//             icon={Globe}
//             color={rexTechTheme.colors.accent.blue}
//             unit="kg"
//             loading={isRefreshing}
//           /> */}
//         </div>

//         {/* Materials Recycled Graph */}
//         <div style={{
//           backgroundColor: rexTechTheme.colors.neutral.white,
//           borderRadius: rexTechTheme.borderRadius.large,
//           padding: rexTechTheme.spacing.xl,
//           boxShadow: rexTechTheme.shadows.light,
//           border: `1px solid ${rexTechTheme.colors.neutral.gray}`,
//           marginBottom: rexTechTheme.spacing.xl
//         }}>
//           <div style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             marginBottom: rexTechTheme.spacing.lg
//           }}>
//             <div>
//               <h3 style={{
//                 color: rexTechTheme.colors.primary.dark,
//                 fontSize: rexTechTheme.typography.fontSize.xlarge,
//                 fontWeight: rexTechTheme.typography.fontWeight.bold,
//                 margin: 0,
//                 marginBottom: rexTechTheme.spacing.xs,
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: rexTechTheme.spacing.sm
//               }}>
//                 <Globe size={24} />
//                 Materials Recycled by Whole Company
//               </h3>
//               <p style={{
//                 color: rexTechTheme.colors.neutral.darkGray,
//                 fontSize: rexTechTheme.typography.fontSize.small,
//                 margin: 0
//               }}>
//                 {periodFilter === 'day' ? 'Daily' : periodFilter === 'week' ? 'Weekly' : 'Monthly'} recycling progress
//               </p>
//             </div>
            
//             <div style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: rexTechTheme.spacing.lg
//             }}>
//               <div style={{ display: 'flex', alignItems: 'center', gap: rexTechTheme.spacing.xs }}>
//                 <div style={{
//                   width: '12px',
//                   height: '12px',
//                   backgroundColor: rexTechTheme.colors.primary.main,
//                   borderRadius: '2px'
//                 }} />
//                 <span style={{
//                   fontSize: rexTechTheme.typography.fontSize.small,
//                   color: rexTechTheme.colors.neutral.darkGray
//                 }}>
//                   Materials (kg)
//                 </span>
//               </div>
//               <div style={{ display: 'flex', alignItems: 'center', gap: rexTechTheme.spacing.xs }}>
//                 <div style={{
//                   width: '12px',
//                   height: '12px',
//                   backgroundColor: rexTechTheme.colors.primary.main,
//                   borderRadius: '2px'
//                 }} />
//                 <span style={{
//                   fontSize: rexTechTheme.typography.fontSize.small,
//                   color: rexTechTheme.colors.neutral.darkGray
//                 }}>
//                   CO2 Saved (kg)
//                 </span>
//               </div>
//             </div>
//           </div>
          
//           <div style={{ height: '400px' }}>
//             {materialsRecycledData.length > 0 ? (
//               <ResponsiveContainer width="100%" height="100%">
//                 <BarChart data={materialsRecycledData}>
//                   <CartesianGrid strokeDasharray="3 3" stroke={rexTechTheme.colors.neutral.gray} />
//                   <XAxis 
//                     dataKey="period" 
//                     stroke={rexTechTheme.colors.neutral.darkGray}
//                     fontSize={12}
//                     label={{ value: 'Period', position: 'insideBottom', offset: -5 }}
//                   />
//                   <YAxis 
//                     stroke={rexTechTheme.colors.neutral.darkGray}
//                     fontSize={12}
//                     label={{ 
//                       value: 'Amount (kg)', 
//                       angle: -90, 
//                       position: 'insideLeft',
//                       offset: 10 
//                     }}
//                   />
//                   <Tooltip content={<CustomTooltip />} />
//                   <Legend />
//                   <Bar 
//                     dataKey="amount" 
//                     name="Materials Recycled"
//                     fill={rexTechTheme.colors.primary.main}
//                     radius={[4, 4, 0, 0]}
//                   />
//                   <Bar 
//                     dataKey="co2Saved" 
//                     name="CO2 Saved"
//                     fill={rexTechTheme.colors.accent.teal}
//                     radius={[4, 4, 0, 0]}
//                   />
//                 </BarChart>
//               </ResponsiveContainer>
//             ) : (
//               <div style={{
//                 height: '100%',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 color: rexTechTheme.colors.neutral.darkGray,
//                 textAlign: 'center'
//               }}>
//                 <TrendingUp size={48} style={{ marginBottom: rexTechTheme.spacing.md, opacity: 0.5 }} />
//                 <p>No materials recycled data available for the selected period</p>
//                 <p style={{
//                   fontSize: rexTechTheme.typography.fontSize.small,
//                   color: rexTechTheme.colors.neutral.darkGray,
//                   marginTop: rexTechTheme.spacing.sm
//                 }}>
//                   Select a different time period or check back later
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Add CSS animations */}
//       <style>{`
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//         .spin {
//           animation: spin 1s linear infinite;
//         }
        
//         /* Custom scrollbar */
//         ::-webkit-scrollbar {
//           width: 8px;
//         }
//         ::-webkit-scrollbar-track {
//           background: #f1f1f1;
//           border-radius: 4px;
//         }
//         ::-webkit-scrollbar-thumb {
//           background: #888;
//           border-radius: 4px;
//         }
//         ::-webkit-scrollbar-thumb:hover {
//           background: #555;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ClientDashboard;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ClientHeader from '../Common/Layout/ClientHeader';
import { rexTechTheme } from '../Common/Theme';
import {
  GitBranch,
  Users,
  Package,
  CheckCircle,
  Leaf,
  BarChart3,
  Calendar,
  RefreshCw,
  TrendingUp,
  Globe,
  ArrowUp,
  ArrowDown,
  Smartphone
} from 'lucide-react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

// Import your API configuration
import config from '../Common/Configurations/APIConfig';

const ClientDashboard = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [stats, setStats] = useState({
    branches: 0,
    branchUsers: 0,
    requests: 0,
    requestsCollected: 0,
    co2Reduction: 0,
    totalMaterialsKg: 0
  });

  // Trend data
  const [trendData, setTrendData] = useState({
    branchTrend: '0%',
    branchDirection: 'up',
    co2Trend: '0%',
    co2Direction: 'up'
  });

  // Materials recycled data for graph
  const [materialsRecycledData, setMaterialsRecycledData] = useState([]);
  
  // Filter states
  const [periodFilter, setPeriodFilter] = useState('week');
  
  // Mobile state
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle resize for mobile detection
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch dashboard data
  const fetchDashboardData = async (period = periodFilter) => {
    try {
      setIsLoading(true);
      setIsRefreshing(true);
      
      // Get current user ID
      const userId = localStorage.getItem('userId');
      
      if (!userId) {
        console.error('No user ID found. User might not be logged in.');
        alert('Please log in to view dashboard data.');
        navigate('/login');
        return;
      }

      // Single API call for all dashboard data - Updated endpoint
      const response = await axios.get(
        `${config.APIACTIVEURL}dashboard/data?userId=${userId}&period=${period}`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.success) {
        const dashboardData = response.data.data;
        const stats = dashboardData.stats;
        
        // Update stats for cards
        setStats({
          branches: stats?.branches || 0,
          branchUsers: stats?.branchUsers || 0,
          requests: stats?.requests || 0,
          requestsCollected: stats?.requestsCollected || 0,
          co2Reduction: stats?.co2ReductionKg || 0,
          totalMaterialsKg: stats?.totalMaterialsKg || 0
        });

        // Update trend data
        setTrendData({
          branchTrend: stats?.branchTrend || '0%',
          branchDirection: stats?.branchTrendDirection || 'up',
          co2Trend: stats?.co2Trend || '0%',
          co2Direction: stats?.co2TrendDirection || 'up'
        });

        // Update chart data
        if (dashboardData?.materialsChartData && dashboardData.materialsChartData.length > 0) {
          setMaterialsRecycledData(dashboardData.materialsChartData.map(item => ({
            period: item.period,
            amount: item.amount || 0,
            co2Saved: item.co2Saved || 0
          })));
        } else {
          setMaterialsRecycledData([]);
        }
      } else {
        alert(`Failed to load dashboard data: ${response.data.message}`);
      }

    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      
      // Handle errors
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        navigate('/login');
      } else if (error.response?.status === 403) {
        alert('Access denied. You need client privileges.');
      } else if (error.response?.status === 400) {
        alert(`Bad request: ${error.response.data.message}`);
      } else if (error.response?.status === 404) {
        // Try the dashboard endpoint without "client" prefix as fallback
        console.log('Trying alternative endpoint...');
        // You might want to implement a fallback here
      } else {
        alert('Failed to load dashboard data. Please try again.');
      }
    } finally {
      setIsLoading(false);
      setIsRefreshing(false);
    }
  };

  // Initial data fetch
  useEffect(() => {
    fetchDashboardData();
  }, []);

  // Handle period change
  const handlePeriodChange = (period) => {
    setPeriodFilter(period);
    fetchDashboardData(period);
  };

  // Handle refresh
  const handleRefresh = () => {
    fetchDashboardData();
  };

  // Stats Card Component
  const StatsCard = ({ title, value, icon: Icon, color, trendValue, trendDirection, unit, loading }) => {
    const formatValue = (val) => {
      if (unit === 'kg' && val >= 1000) {
        return `${(val / 1000).toFixed(1)}`;
      }
      if (unit === 'kg') {
        return `${val.toLocaleString()}`;
      }
      return val.toLocaleString();
    };

    const getUnitDisplay = () => {
      if (unit === 'kg' && value >= 1000) return 'tons';
      if (unit === 'kg') return 'kg';
      return '';
    };

    const TrendIcon = trendDirection === 'up' ? ArrowUp : ArrowDown;
    const trendColor = trendDirection === 'up' ? rexTechTheme.colors.primary.main : '#dc3545';

    return (
      <div
        style={{
          backgroundColor: rexTechTheme.colors.neutral.white,
          borderRadius: rexTechTheme.borderRadius.large,
          padding: isMobile ? rexTechTheme.spacing.md : rexTechTheme.spacing.xl,
          boxShadow: rexTechTheme.shadows.light,
          border: `1px solid ${rexTechTheme.colors.neutral.gray}`,
          transition: 'all 0.3s ease',
          position: 'relative',
          overflow: 'hidden',
          minHeight: isMobile ? '120px' : '140px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        {/* Background accent */}
        <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '50px',
          height: '50px',
          backgroundColor: `${color}10`,
          borderRadius: '0 0 0 100%',
          transition: 'all 0.3s ease'
        }} />
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div style={{ flex: 1 }}>
            <p style={{
              color: rexTechTheme.colors.neutral.darkGray,
              fontSize: isMobile ? rexTechTheme.typography.fontSize.small : rexTechTheme.typography.fontSize.regular,
              marginBottom: rexTechTheme.spacing.xs,
              fontWeight: rexTechTheme.typography.fontWeight.medium
            }}>
              {title}
            </p>
            <div style={{
              display: 'flex',
              alignItems: 'baseline',
              gap: rexTechTheme.spacing.xs,
              minHeight: '40px'
            }}>
              <h3 style={{
                color: rexTechTheme.colors.primary.dark,
                fontSize: isMobile ? rexTechTheme.typography.fontSize.xlarge : rexTechTheme.typography.fontSize.xxxlarge,
                fontWeight: rexTechTheme.typography.fontWeight.bold,
                margin: 0,
                lineHeight: 1
              }}>
                {loading ? (
                  <div style={{
                    width: '20px',
                    height: '20px',
                    border: `2px solid ${rexTechTheme.colors.primary.light}`,
                    borderTopColor: rexTechTheme.colors.primary.main,
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }} />
                ) : (
                  formatValue(value)
                )}
              </h3>
              {unit && !loading && (
                <span style={{
                  color: rexTechTheme.colors.neutral.darkGray,
                  fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
                  fontWeight: rexTechTheme.typography.fontWeight.medium
                }}>
                  {getUnitDisplay()}
                </span>
              )}
            </div>
            
            {trendValue && !loading && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: rexTechTheme.spacing.xs,
                marginTop: rexTechTheme.spacing.sm
              }}>
                <TrendIcon size={isMobile ? 14 : 16} color={trendColor} />
                <span style={{
                  color: trendColor,
                  fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
                  fontWeight: rexTechTheme.typography.fontWeight.semiBold
                }}>
                  {trendValue}
                </span>
                {!isMobile && (
                  <span style={{
                    color: rexTechTheme.colors.neutral.darkGray,
                    fontSize: rexTechTheme.typography.fontSize.xs,
                    marginLeft: rexTechTheme.spacing.xs
                  }}>
                    from last month
                  </span>
                )}
              </div>
            )}
          </div>
          
          <div style={{
            width: isMobile ? '36px' : '48px',
            height: isMobile ? '36px' : '48px',
            borderRadius: '12px',
            backgroundColor: `${color}20`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: color,
            flexShrink: 0
          }}>
            <Icon size={isMobile ? 18 : 24} />
          </div>
        </div>
      </div>
    );
  };

  // Custom Tooltip for Chart
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          backgroundColor: rexTechTheme.colors.neutral.white,
          border: `1px solid ${rexTechTheme.colors.neutral.gray}`,
          padding: rexTechTheme.spacing.md,
          borderRadius: rexTechTheme.borderRadius.medium,
          boxShadow: rexTechTheme.shadows.medium,
          fontSize: isMobile ? rexTechTheme.typography.fontSize.small : rexTechTheme.typography.fontSize.regular
        }}>
          <p style={{
            margin: 0,
            color: rexTechTheme.colors.primary.dark,
            fontWeight: 'bold',
            marginBottom: rexTechTheme.spacing.xs,
            fontSize: isMobile ? rexTechTheme.typography.fontSize.small : 'inherit'
          }}>
            {label}
          </p>
          {payload.map((entry, index) => (
            <p key={index} style={{
              margin: 0,
              color: entry.color,
              fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
              display: 'flex',
              alignItems: 'center',
              gap: rexTechTheme.spacing.xs,
              marginBottom: rexTechTheme.spacing.xs
            }}>
              <div style={{
                width: isMobile ? '8px' : '10px',
                height: isMobile ? '8px' : '10px',
                backgroundColor: entry.color,
                borderRadius: '2px'
              }} />
              {entry.name}: <strong>{entry.value.toLocaleString()} kg</strong>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  // Loading skeleton
  const LoadingSkeleton = () => (
    <div style={{
      minHeight: '100vh',
      backgroundColor: rexTechTheme.colors.neutral.lightGray,
      fontFamily: rexTechTheme.typography.fontFamily
    }}>
      <ClientHeader />
      
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: isMobile ? rexTechTheme.spacing.md : rexTechTheme.spacing.xl
      }}>
        {/* Header skeleton */}
        <div style={{ marginBottom: isMobile ? rexTechTheme.spacing.lg : rexTechTheme.spacing.xl }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: rexTechTheme.spacing.lg,
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? rexTechTheme.spacing.md : 0
          }}>
            <div style={{ width: isMobile ? '100%' : 'auto' }}>
              <div style={{
                width: isMobile ? '150px' : '200px',
                height: '32px',
                backgroundColor: rexTechTheme.colors.neutral.gray,
                borderRadius: rexTechTheme.borderRadius.medium,
                marginBottom: rexTechTheme.spacing.xs
              }} />
              <div style={{
                width: isMobile ? '250px' : '300px',
                height: '20px',
                backgroundColor: rexTechTheme.colors.neutral.gray,
                borderRadius: rexTechTheme.borderRadius.medium
              }} />
            </div>
            <div style={{
              width: isMobile ? '100%' : '120px',
              height: '40px',
              backgroundColor: rexTechTheme.colors.neutral.gray,
              borderRadius: rexTechTheme.borderRadius.medium,
              marginTop: isMobile ? rexTechTheme.spacing.sm : 0
            }} />
          </div>
        </div>

        {/* Stats grid skeleton */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: rexTechTheme.spacing.lg,
          marginBottom: rexTechTheme.spacing.xl
        }}>
          {[1, 2, 3, 4, 5].map((item) => (
            <div key={item} style={{
              backgroundColor: rexTechTheme.colors.neutral.white,
              borderRadius: rexTechTheme.borderRadius.large,
              padding: isMobile ? rexTechTheme.spacing.md : rexTechTheme.spacing.xl,
              height: isMobile ? '120px' : '140px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}>
              <div style={{
                width: '80px',
                height: '20px',
                backgroundColor: rexTechTheme.colors.neutral.gray,
                borderRadius: rexTechTheme.borderRadius.medium
              }} />
              <div style={{
                width: '60px',
                height: '32px',
                backgroundColor: rexTechTheme.colors.neutral.gray,
                borderRadius: rexTechTheme.borderRadius.medium
              }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  if (isLoading) {
    return <LoadingSkeleton />;
  }

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: rexTechTheme.colors.neutral.lightGray,
      fontFamily: rexTechTheme.typography.fontFamily
    }}>
      <ClientHeader />
      
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: isMobile ? rexTechTheme.spacing.md : rexTechTheme.spacing.xl
      }}>
        {/* Header */}
        <div style={{
          marginBottom: isMobile ? rexTechTheme.spacing.lg : rexTechTheme.spacing.xl
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: rexTechTheme.spacing.lg,
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? rexTechTheme.spacing.md : 0,
            alignItems: isMobile ? 'stretch' : 'center'
          }}>
            <div style={{ width: isMobile ? '100%' : 'auto' }}>
              <h1 style={{
                fontSize: isMobile ? rexTechTheme.typography.fontSize.xlarge : rexTechTheme.typography.fontSize.xxlarge,
                color: rexTechTheme.colors.primary.dark,
                fontWeight: rexTechTheme.typography.fontWeight.bold,
                marginBottom: rexTechTheme.spacing.xs,
                display: 'flex',
                alignItems: 'center',
                gap: rexTechTheme.spacing.sm
              }}>
                <BarChart3 size={isMobile ? 24 : 32} />
                Client Dashboard
                {isMobile && <Smartphone size={16} style={{ marginLeft: 'auto' }} />}
              </h1>
              <p style={{
                color: rexTechTheme.colors.neutral.darkGray,
                fontSize: isMobile ? rexTechTheme.typography.fontSize.small : rexTechTheme.typography.fontSize.regular,
                margin: 0,
                display: 'flex',
                alignItems: 'center',
                gap: rexTechTheme.spacing.sm
              }}>
                <Calendar size={isMobile ? 14 : 16} />
                {new Date().toLocaleDateString('en-US', { 
                  weekday: isMobile ? 'short' : 'long', 
                  year: 'numeric', 
                  month: isMobile ? 'short' : 'long', 
                  day: 'numeric' 
                })}
              </p>
            </div>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: rexTechTheme.spacing.md,
              width: isMobile ? '100%' : 'auto',
              justifyContent: isMobile ? 'center' : 'flex-end'
            }}>
              <button
                onClick={handleRefresh}
                disabled={isRefreshing}
                style={{
                  padding: isMobile ? 
                    `${rexTechTheme.spacing.xs} ${rexTechTheme.spacing.md}` : 
                    `${rexTechTheme.spacing.sm} ${rexTechTheme.spacing.lg}`,
                  backgroundColor: rexTechTheme.colors.neutral.white,
                  border: `1px solid ${rexTechTheme.colors.neutral.gray}`,
                  borderRadius: rexTechTheme.borderRadius.medium,
                  cursor: 'pointer',
                  color: rexTechTheme.colors.primary.dark,
                  fontSize: isMobile ? rexTechTheme.typography.fontSize.small : rexTechTheme.typography.fontSize.regular,
                  fontWeight: rexTechTheme.typography.fontWeight.semiBold,
                  display: 'flex',
                  alignItems: 'center',
                  gap: rexTechTheme.spacing.sm,
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto',
                  justifyContent: 'center',
                  ':hover': {
                    backgroundColor: rexTechTheme.colors.neutral.lightGray
                  },
                  ':disabled': {
                    opacity: 0.6,
                    cursor: 'not-allowed'
                  }
                }}
              >
                <RefreshCw size={isMobile ? 16 : 18} className={isRefreshing ? 'spin' : ''} />
                {isRefreshing ? 'Refreshing...' : 'Refresh'}
              </button>
            </div>
          </div>
          
          {/* Date Filters */}
          <div style={{
            backgroundColor: rexTechTheme.colors.neutral.white,
            borderRadius: rexTechTheme.borderRadius.large,
            padding: isMobile ? rexTechTheme.spacing.md : rexTechTheme.spacing.lg,
            boxShadow: rexTechTheme.shadows.light,
            border: `1px solid ${rexTechTheme.colors.neutral.gray}`,
            marginBottom: rexTechTheme.spacing.lg
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: rexTechTheme.spacing.sm,
              flexWrap: isMobile ? 'wrap' : 'nowrap',
              justifyContent: isMobile ? 'center' : 'flex-start'
            }}>
              <span style={{
                color: rexTechTheme.colors.neutral.darkGray,
                fontWeight: rexTechTheme.typography.fontWeight.medium,
                fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
                width: isMobile ? '100%' : 'auto',
                textAlign: isMobile ? 'center' : 'left',
                marginBottom: isMobile ? rexTechTheme.spacing.xs : 0
              }}>
                View Data:
              </span>
              <div style={{
                display: 'flex',
                gap: rexTechTheme.spacing.xs,
                flexWrap: isMobile ? 'wrap' : 'nowrap',
                justifyContent: 'center',
                width: isMobile ? '100%' : 'auto'
              }}>
                <button
                  onClick={() => handlePeriodChange('day')}
                  style={{
                    padding: isMobile ? 
                      `${rexTechTheme.spacing.xxs} ${rexTechTheme.spacing.sm}` : 
                      `${rexTechTheme.spacing.xs} ${rexTechTheme.spacing.lg}`,
                    backgroundColor: periodFilter === 'day' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.white,
                    border: `1px solid ${periodFilter === 'day' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.gray}`,
                    borderRadius: rexTechTheme.borderRadius.medium,
                    cursor: 'pointer',
                    color: periodFilter === 'day' ? rexTechTheme.colors.neutral.white : rexTechTheme.colors.primary.dark,
                    fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
                    fontWeight: rexTechTheme.typography.fontWeight.semiBold,
                    transition: 'all 0.2s ease',
                    flex: isMobile ? 1 : 'none',
                    minWidth: isMobile ? '80px' : 'auto',
                    ':hover': {
                      backgroundColor: periodFilter === 'day' ? rexTechTheme.colors.primary.dark : rexTechTheme.colors.neutral.lightGray
                    }
                  }}
                >
                  {isMobile ? 'Today' : 'Today'}
                </button>
                <button
                  onClick={() => handlePeriodChange('week')}
                  style={{
                    padding: isMobile ? 
                      `${rexTechTheme.spacing.xxs} ${rexTechTheme.spacing.sm}` : 
                      `${rexTechTheme.spacing.xs} ${rexTechTheme.spacing.lg}`,
                    backgroundColor: periodFilter === 'week' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.white,
                    border: `1px solid ${periodFilter === 'week' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.gray}`,
                    borderRadius: rexTechTheme.borderRadius.medium,
                    cursor: 'pointer',
                    color: periodFilter === 'week' ? rexTechTheme.colors.neutral.white : rexTechTheme.colors.primary.dark,
                    fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
                    fontWeight: rexTechTheme.typography.fontWeight.semiBold,
                    transition: 'all 0.2s ease',
                    flex: isMobile ? 1 : 'none',
                    minWidth: isMobile ? '80px' : 'auto',
                    ':hover': {
                      backgroundColor: periodFilter === 'week' ? rexTechTheme.colors.primary.dark : rexTechTheme.colors.neutral.lightGray
                    }
                  }}
                >
                  {isMobile ? 'Week' : 'This Week'}
                </button>
                <button
                  onClick={() => handlePeriodChange('month')}
                  style={{
                    padding: isMobile ? 
                      `${rexTechTheme.spacing.xxs} ${rexTechTheme.spacing.sm}` : 
                      `${rexTechTheme.spacing.xs} ${rexTechTheme.spacing.lg}`,
                    backgroundColor: periodFilter === 'month' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.white,
                    border: `1px solid ${periodFilter === 'month' ? rexTechTheme.colors.primary.main : rexTechTheme.colors.neutral.gray}`,
                    borderRadius: rexTechTheme.borderRadius.medium,
                    cursor: 'pointer',
                    color: periodFilter === 'month' ? rexTechTheme.colors.neutral.white : rexTechTheme.colors.primary.dark,
                    fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
                    fontWeight: rexTechTheme.typography.fontWeight.semiBold,
                    transition: 'all 0.2s ease',
                    flex: isMobile ? 1 : 'none',
                    minWidth: isMobile ? '80px' : 'auto',
                    ':hover': {
                      backgroundColor: periodFilter === 'month' ? rexTechTheme.colors.primary.dark : rexTechTheme.colors.neutral.lightGray
                    }
                  }}
                >
                  {isMobile ? 'Month' : 'This Month'}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Grid - 5 Cards with Trends */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: rexTechTheme.spacing.lg,
          marginBottom: rexTechTheme.spacing.xl
        }}>
          <StatsCard
            title="Branches"
            value={stats.branches}
            icon={GitBranch}
            color={rexTechTheme.colors.secondary.main}
            trendValue={trendData.branchTrend}
            trendDirection={trendData.branchDirection}
            loading={isRefreshing}
          />
          
          <StatsCard
            title="Branch Users"
            value={stats.branchUsers}
            icon={Users}
            color={rexTechTheme.colors.primary.light}
            loading={isRefreshing}
          />
          
          <StatsCard
            title="Requests"
            value={stats.requests}
            icon={Package}
            color={rexTechTheme.colors.accent.orange}
            loading={isRefreshing}
          />
          
          <StatsCard
            title="Requests Collected"
            value={stats.requestsCollected}
            icon={CheckCircle}
            color={rexTechTheme.colors.primary.main}
            loading={isRefreshing}
          />
          
          <StatsCard
            title="CO2 Reduction"
            value={stats.co2Reduction}
            icon={Leaf}
            color={rexTechTheme.colors.primary.main}
            trendValue={trendData.co2Trend}
            trendDirection={trendData.co2Direction}
            unit="kg"
            loading={isRefreshing}
          />
        </div>

        {/* Materials Recycled Graph - Mobile Optimized */}
        <div style={{
          backgroundColor: rexTechTheme.colors.neutral.white,
          borderRadius: rexTechTheme.borderRadius.large,
          padding: isMobile ? rexTechTheme.spacing.md : rexTechTheme.spacing.xl,
          boxShadow: rexTechTheme.shadows.light,
          border: `1px solid ${rexTechTheme.colors.neutral.gray}`,
          marginBottom: rexTechTheme.spacing.xl,
          overflowX: 'auto'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: isMobile ? 'flex-start' : 'center',
            marginBottom: rexTechTheme.spacing.lg,
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? rexTechTheme.spacing.md : 0
          }}>
            <div style={{ width: isMobile ? '100%' : 'auto' }}>
              <h3 style={{
                color: rexTechTheme.colors.primary.dark,
                fontSize: isMobile ? rexTechTheme.typography.fontSize.large : rexTechTheme.typography.fontSize.xlarge,
                fontWeight: rexTechTheme.typography.fontWeight.bold,
                margin: 0,
                marginBottom: rexTechTheme.spacing.xs,
                display: 'flex',
                alignItems: 'center',
                gap: rexTechTheme.spacing.sm
              }}>
                <Globe size={isMobile ? 20 : 24} />
                {isMobile ? 'Materials Recycled' : 'Materials Recycled by Whole Company'}
              </h3>
              <p style={{
                color: rexTechTheme.colors.neutral.darkGray,
                fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
                margin: 0
              }}>
                {periodFilter === 'day' ? 'Daily' : periodFilter === 'week' ? 'Weekly' : 'Monthly'} recycling progress
              </p>
            </div>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: isMobile ? rexTechTheme.spacing.sm : rexTechTheme.spacing.lg,
              flexWrap: 'wrap',
              marginTop: isMobile ? rexTechTheme.spacing.sm : 0
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: rexTechTheme.spacing.xs }}>
                <div style={{
                  width: isMobile ? '10px' : '12px',
                  height: isMobile ? '10px' : '12px',
                  backgroundColor: rexTechTheme.colors.primary.main,
                  borderRadius: '2px'
                }} />
                <span style={{
                  fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
                  color: rexTechTheme.colors.neutral.darkGray
                }}>
                  {isMobile ? 'Materials' : 'Materials (kg)'}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: rexTechTheme.spacing.xs }}>
                <div style={{
                  width: isMobile ? '10px' : '12px',
                  height: isMobile ? '10px' : '12px',
                  backgroundColor: rexTechTheme.colors.accent.teal,
                  borderRadius: '2px'
                }} />
                <span style={{
                  fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
                  color: rexTechTheme.colors.neutral.darkGray
                }}>
                  {isMobile ? 'CO2 Saved' : 'CO2 Saved (kg)'}
                </span>
              </div>
            </div>
          </div>
          
          <div style={{ 
            height: isMobile ? '300px' : '400px',
            minWidth: isMobile ? '600px' : 'auto', // Ensure minimum width for horizontal scroll on mobile
            overflowX: isMobile ? 'auto' : 'hidden'
          }}>
            {materialsRecycledData.length > 0 ? (
              <ResponsiveContainer width={isMobile ? Math.max(600, materialsRecycledData.length * 50) : "100%"} height="100%">
                <BarChart 
                  data={materialsRecycledData}
                  margin={isMobile ? { top: 20, right: 10, left: 0, bottom: 20 } : { top: 20, right: 30, left: 20, bottom: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" stroke={rexTechTheme.colors.neutral.gray} />
                  <XAxis 
                    dataKey="period" 
                    stroke={rexTechTheme.colors.neutral.darkGray}
                    fontSize={isMobile ? 10 : 12}
                    angle={isMobile ? -45 : 0}
                    textAnchor={isMobile ? 'end' : 'middle'}
                    height={isMobile ? 60 : 40}
                    interval={isMobile ? 0 : 'preserveStartEnd'}
                    tick={{ fill: rexTechTheme.colors.neutral.darkGray }}
                  />
                  <YAxis 
                    stroke={rexTechTheme.colors.neutral.darkGray}
                    fontSize={isMobile ? 10 : 12}
                    tick={{ fill: rexTechTheme.colors.neutral.darkGray }}
                    width={isMobile ? 40 : 60}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend 
                    verticalAlign={isMobile ? 'top' : 'top'}
                    height={isMobile ? 30 : 36}
                    wrapperStyle={{ fontSize: isMobile ? '10px' : '12px' }}
                  />
                  <Bar 
                    dataKey="amount" 
                    name="Materials"
                    fill={rexTechTheme.colors.primary.main}
                    radius={[4, 4, 0, 0]}
                    barSize={isMobile ? 30 : 40}
                  />
                  <Bar 
                    dataKey="co2Saved" 
                    name="CO2 Saved"
                    fill={rexTechTheme.colors.accent.teal}
                    radius={[4, 4, 0, 0]}
                    barSize={isMobile ? 30 : 40}
                  />
                </BarChart>
              </ResponsiveContainer>
            ) : (
              <div style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: rexTechTheme.colors.neutral.darkGray,
                textAlign: 'center',
                padding: isMobile ? rexTechTheme.spacing.md : rexTechTheme.spacing.xl
              }}>
                <TrendingUp size={isMobile ? 36 : 48} style={{ marginBottom: rexTechTheme.spacing.md, opacity: 0.5 }} />
                <p style={{
                  fontSize: isMobile ? rexTechTheme.typography.fontSize.small : rexTechTheme.typography.fontSize.regular,
                  marginBottom: rexTechTheme.spacing.sm
                }}>
                  No materials recycled data available for the selected period
                </p>
                <p style={{
                  fontSize: isMobile ? rexTechTheme.typography.fontSize.xs : rexTechTheme.typography.fontSize.small,
                  color: rexTechTheme.colors.neutral.darkGray,
                  marginTop: rexTechTheme.spacing.sm
                }}>
                  Select a different time period or check back later
                </p>
              </div>
            )}
          </div>
          
          {/* Mobile scroll hint */}
          {isMobile && materialsRecycledData.length > 3 && (
            <div style={{
              textAlign: 'center',
              marginTop: rexTechTheme.spacing.md,
              color: rexTechTheme.colors.neutral.darkGray,
              fontSize: rexTechTheme.typography.fontSize.xs,
              fontStyle: 'italic'
            }}>
              ← Scroll horizontally to view all data →
            </div>
          )}
        </div>
      </div>

      {/* Add CSS animations */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .spin {
          animation: spin 1s linear infinite;
        }
        
        /* Custom scrollbar for mobile */
        ::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }
        ::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 4px;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        
        /* Mobile optimizations */
        @media (max-width: 767px) {
          .mobile-scroll-hint {
            position: sticky;
            bottom: 10px;
            background: rgba(255, 255, 255, 0.9);
            padding: 8px;
            border-radius: 8px;
            text-align: center;
            font-size: 12px;
            color: #666;
          }
        }
      `}</style>
    </div>
  );
};

export default ClientDashboard;